import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import './styles/tokens.css'
import './styles/app.css'

const client = new QueryClient({
  defaultOptions: {
    queries: {
      // A failed request is shown as failed. Retrying three times silently means an
      // analyst stares at a spinner for ten seconds and then sees a blank list with
      // no idea that anything went wrong.
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
